var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBriefcase(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3346 16.5V3.16667C13.3346 2.72464 13.159 2.30072 12.8465 1.98816C12.5339 1.67559 12.11 1.5 11.668 1.5H8.33464C7.89261 1.5 7.46869 1.67559 7.15612 1.98816C6.84356 2.30072 6.66797 2.72464 6.66797 3.16667V16.5M3.33464 4.83333H16.668C17.5884 4.83333 18.3346 5.57953 18.3346 6.5V14.8333C18.3346 15.7538 17.5884 16.5 16.668 16.5H3.33464C2.41416 16.5 1.66797 15.7538 1.66797 14.8333V6.5C1.66797 5.57953 2.41416 4.83333 3.33464 4.83333Z",
    stroke: "#7F818D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBriefcase);
export default __webpack_public_path__ + "static/media/briefcase.5992d058acdb145c2d2d834a6e987dd0.svg";
export { ForwardRef as ReactComponent };